module.exports = __webpack_public_path__ + "img/jkopay.fef5ded9.png";